import { Outlet } from "react-router-dom";
import Sidebar from "@/components/layout/Sidebar";
import Header from "@/components/layout/Header";
import IncomingCallWidget from "@/components/conversations/IncomingCallWidget";

export default function DashboardLayout() {
  // Fix AI (2026-10-23): h-dvh = alto visible real en el celular (h-screen queda tapado por la barra del navegador)
  return (
    <div className="flex h-screen h-dvh bg-background font-sans overflow-hidden">
      <aside className="hidden lg:block w-64 shrink-0 border-r border-border">
        <Sidebar />
      </aside>
      <div className="flex-1 flex flex-col min-w-0">
        <Header />
        <main className="flex-1 overflow-y-auto p-4 sm:p-6 lg:p-8">
          <div className="max-w-7xl mx-auto animate-in fade-in slide-in-from-bottom-4 duration-500">
            <Outlet />
          </div>
        </main>
      </div>
      {/* Fix AH (2026-10-21): aviso de llamadas de WhatsApp en cualquier pantalla */}
      <IncomingCallWidget />
    </div>
  );
}
